import { useFocusTimer } from "./FocusTimerProvider";
import "./FocusTimer.css";

function TimerPanel() {
  const {
    timer,
    start,
    pause,
    reset,
    changeMode,
    toggleMinimize,
  } = useFocusTimer();

  const minutes = Math.floor(timer.remaining / 60)
    .toString()
    .padStart(2, "0");

  const seconds = (timer.remaining % 60)
    .toString()
    .padStart(2, "0");

  // Notes for each mode
  const modeNotes = {
    focus: "Deep work. Study or build without distractions.",
    short: "Recharge. Take a proper break away from the screen",
    long: "15 min break — do a small task or rest."
  };

  return (
    <div
      className={`timer-panel-overlay ${
        timer.isMinimized ? "hidden" : "visible"
      }`}
    >
      <div className="timer-panel">
        {/* Header */}
        <div className="panel-header">
          <h3>Focus Timer</h3>
          <button
            className="shrink-btn"
            onClick={toggleMinimize}
          >
            ⤢
          </button>
        </div>

        {/* Mode Switch */}
        <div className="mode-switch">
          {["focus", "short", "long"].map((mode) => (
            <button
              key={mode}
              className={`mode-btn ${
                timer.mode === mode ? "active" : ""
              }`}
              onClick={() => changeMode(mode)}
            >
              {mode.charAt(0).toUpperCase() +
                mode.slice(1)}
            </button>
          ))}
        </div>

        {/* Time Display */}
        <div className="timer-display">
          {minutes}:{seconds}
        </div>

        {/* Mode Note */}
        <div className="mode-note">
          {modeNotes[timer.mode]}
        </div>

        {/* Controls */}
        <div className="timer-controls">
          {!timer.isRunning ? (
            <button
              className="control-btn primary"
              onClick={start}
            >
              ▶ Start
            </button>
          ) : (
            <button
              className="control-btn pause"
              onClick={pause}
            >
              ⏸ Pause
            </button>
          )}

          <button
            className="control-btn reset"
            onClick={reset}
          >
            ↺ Reset
          </button>
        </div>
      </div>
    </div>
  );
}

export default TimerPanel;